module.exports = __webpack_public_path__ + "img/16.27f8b881.png";